import { useState } from "react"
import LeftDrawer from "./components/drawer/LeftDrawer"
import Footer from "./components/footer/Footer"
import Navbar from "./components/navbar/Navbar"
import "./SuvaiWrapper.scss"
// import config from "react-global-configuration";
// import store from "../../../../../redux/rootreducer"

const SuvaiWrapper = ({ children }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false)
    // const isStandalone = !!window.__COMPANY_DATA__;
    // const downloadTheme = async () => {
    //     const companyData = {
    //         // API config
    //         config: {
    //             backendURL: config.get('backendURL'),
    //             API_URL_cust: config.get('API_URL_cust'),
    //             API_productregistry: config.get('API_productregistry'),
    //             rest_API_productregistry: config.get('rest_API_productregistry'),
    //             rest_API_productregistry_V2: config.get('rest_API_productregistry_V2'),
    //             rest_API: config.get('rest_API'),
    //             API_salesregistry: config.get('API_salesregistry'),
    //         },
    //         SubDomain: "www.throbox.com",
    //         CustomerDomain: "https://www.throbox.com",
    //     };

    //     const res = await fetch(`${process.env.PUBLIC_URL}/themes/suvai/index.html`);
    //     let html = await res.text();

    //     html = html.replace(
    //         '<script',
    //         `<script>window.__COMPANY_DATA__ = ${JSON.stringify(companyData)};</script>\n<script`
    //     );

    //     const blob = new Blob([html], { type: 'text/html' });
    //     const url = URL.createObjectURL(blob);
    //     const a = document.createElement('a');
    //     a.href = url;
    //     a.download = `index.html`;
    //     a.click();
    //     URL.revokeObjectURL(url);
    // };
    return (
        <>
            <div className="SuvaiWrapper" id="SuvaiWrapper">
                <LeftDrawer
                    isOpen={isMenuOpen}
                    setIsOpen={setIsMenuOpen} />
                <Navbar
                    setIsMenuOpen={setIsMenuOpen} />
                {children}
                <Footer />

            </div>
            {/* {!isStandalone && (<div style={{ height: "100px", backgroundColor: "pink" }}
                onClick={downloadTheme}>
                download

            </div>)} */}
        </>

    )
}
export default SuvaiWrapper